import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getItem, getNext, createItem, updateItem, handleSearch } from "./thunk";

const initialState = {
  items: [],
  edit: false,
  item: null,
  count: null,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingItem: false,
  loadingNext: false,
};

export const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {
    itemEditSuccess: (state, action) => {
      state.edit = true;
      state.item = state.items.find((item) => item.id === action.payload);
    },
    clearAllItem: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingItem = false;
      state.item = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNext.pending, (state) => {
      state.loadingNext = true;
    });
    builder.addCase(getNext.fulfilled, (state, action) => {
      state.loadingNext = false;
      state.next = action.payload.next;
      state.items = [...state.items, ...action.payload.results];
    });
    builder.addCase(getNext.rejected, (state) => {
      state.loadingNext = false;
    });
    builder.addCase(createItem.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createItem.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createItem.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateItem.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateItem.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateItem.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(isAnyOf(getItem.pending, handleSearch.pending), (state) => {
      state.loadingItem = true;
    });
    builder.addMatcher(isAnyOf(getItem.fulfilled, handleSearch.fulfilled), (state, action) => {
      state.loadingItem = false;
      state.items = action.payload.results;
      state.count = action.payload.count;
      state.previous = action.payload.previous;
      state.next = action.payload.next;
    });
    builder.addMatcher(isAnyOf(getItem.rejected, handleSearch.rejected), (state) => {
      state.loadingItem = false;
    });
  },
});

export const { itemEditSuccess, clearAllItem } = itemSlice.actions;

export default itemSlice.reducer;
